module.exports = __webpack_public_path__ + "static/media/DSC_5984.9ecb8596.jpg";